import React from 'react';
import PropTypes from 'prop-types';
import { ImageGalleryCard } from '../cards';

/**
 * Body of the Image Gallery config modal — currently a single card. Wrapped
 * in a modal so the contract matches the other style modals and so we can
 * grow it later (e.g. add a per-product image-list card).
 *
 * value: see ImageGalleryCard for the full shape.
 * onChange(field, value) — fires per individual edit (no nested sections).
 */
const ImageGalleryModal = ({ value = {}, onChange, theme, t }) => (
    <ImageGalleryCard value={value} onChange={onChange} theme={theme} t={t} />
);

ImageGalleryModal.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default ImageGalleryModal;
